export const instrumentationAvailabilityTypes = {
    Unavailable: "Unavailable",
    FullyAvailable: "FullyAvailable",
    PartiallyAvailable: "PartiallyAvailable",
    Unspecified: "Unspecified"
};
